import React from 'react';

import PhoneNumberInput from '../PhoneNumberInput';
import FormikField, { FormikFieldProps } from './FormikField';

const FormikPhoneNumberField = (props: FormikFieldProps) => {
  const { field, form, showNoError, formHelperTextClassName, ...other } = props;
  return (
    <FormikField field={field} form={form} showNoError={showNoError} formHelperTextClassName={formHelperTextClassName}>
      <PhoneNumberInput
        onChange={({ target }) => {
          form.setFieldValue(field.name, target.value, true);
        }}
        onBlur={() => {
          form.setTouched({ [field.name]: true });
        }}
        {...other}
        error={!!form.touched[field.name] && !!form.errors[field.name]}
      />
    </FormikField>
  );
};

export default FormikPhoneNumberField;
